// extracted by mini-css-extract-plugin
export default {"add-icon":"DocumentsTable_add-icon__MZc0H"};